import { render } from "./IndexView.vue?vue&type=template&id=041fbf27&scoped=true"
import script from "./IndexView.vue?vue&type=script&lang=js"
export * from "./IndexView.vue?vue&type=script&lang=js"

import "./IndexView.vue?vue&type=style&index=0&id=041fbf27&scoped=true&lang=scss"

import exportComponent from "/root/workspace/tang-h5_cUXP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-041fbf27"]])

export default __exports__